import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from '@model';
import { MenuItemType } from '@enums';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    standalone: false
})
export class MenuComponent implements OnInit {
  @Input()
  menuItems: MenuItem[];
  @Input()
  allItemsText?: string;
  @Input()
  allItemsUrl?: string;
  @Input()
  isHandset: boolean;
  @Input() 
  markAllAsReadText?: string;
  @Input()
  showTimestamps = false;
  @Input()
  evenOddRowStyle = false;
  @Output()
  menuRouteToClick = new EventEmitter<MenuItem>();

  itemTypeFunction: string;
  itemTypeBlank: string;
  itemTypeLink: string;
  itemTypeInfoText: string;
  itemTypeHeading: string;

  constructor(private router: Router) {}

  ngOnInit() {
    this.itemTypeFunction = MenuItemType.Function;
    this.itemTypeBlank = MenuItemType.Blank;
    this.itemTypeLink = MenuItemType.Link;
    this.itemTypeInfoText = MenuItemType.InfoText;
    this.itemTypeHeading = MenuItemType.Heading;
  }

  callbackFunction(callback: any) {
    if (!callback) {
      return;
    }

    callback();
  }

  routeTo(url: string) {
    this.router.navigate([url]);

    if (this.isHandset){
      this.menuRouteToClick.emit();
    }
  }
}
